import { render, staticRenderFns } from "./PBAnalytics.vue?vue&type=template&id=04b43c8a"
import script from "./PBAnalytics.vue?vue&type=script&lang=js"
export * from "./PBAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports